export const CREATE_ADMIN_INSTRUCTOR = "CREATE_ADMIN_INSTRUCTOR";

export const INSTRUCTOR_CRUD_STATUS = "INSTRUCTOR_CRUD_STATUS";

export const GET_ALL_ADMIN_INSTRUCTORS = "GET_ALL_ADMIN_INSTRUCTORS" 

export const INSTRUCTORS_APPROVED = "INSTRUCTORS_APPROVED" 

export const INSTRUCTORS_REJECTED = "INSTRUCTORS_REJECTED" 